module.exports = {
  messages: {
    CN: {
      ExBack: "返回",
      ExOverviewTitle: "还在 LinkedIn 上一个一个手动添加和私信客户？",
      ExSubCopy:
        "StrategyBrain 全部自动搞定 - <strong>适用于任何行业和产品：</strong>",
      ExPainManualTitle: "😩 手动开发客户",
      ExPainSBTitle: "✨ 使用 StrategyBrain",
      ExAnyIndustry: "任何行业：",
      ExAnyIndustryNote: "……任何 B2B 业务都能找到客户",
      ExStep1Title:
        "从<strong>您自己的 LinkedIn 账号</strong>自动锁定目标客户 - 全程无需动手",
      ExFlowAccountTitle: "您自己的 LinkedIn",
      ExFlowAccountStrong: "我们不提供账号",
      ExFlowAccountP: "客户看到的是真实的您",
      ExFlowSourceTitle: "账号自动寻源",
      ExFlowSourceStrong: "全自动 · 零投入",
      ExFlowSourceP: "无需手动搜索或添加",
      ExFlowCustomersTitle: "240 位目标客户",
      ExFlowCustomersP: "匹配您的 ICP<br />自动添加",
      ExHint:
        "只需粘贴一个 LinkedIn 客户搜索 URL - 您的账号会自动完成全部客户开发。",
      ExStep2Title:
        "AI 自动在<strong class=\"blue\">您的 LinkedIn 收件箱</strong>中与目标客户对话（适用于任何行业）",
      ExChatCopy:
        "下面两段对话完全由 AI 自动处理 - <strong>点击任一段可放大查看完整聊天记录：</strong>",
      ExInYourLinkedIn: "在您的 LinkedIn 中",
      ExAccountNote: "您的账号（AI 发送）",
      ExClickEnlarge: "点击放大完整对话",
      ExFootnote:
        "↑ SaaS、制造业、外贸……任何 B2B 行业都可以这样操作。AI 并行跟进全部 240 位目标客户 - 您只需在有结果时介入。",
      ExStep3Title: "自动筛选高意向客户 - 您只接手有结果的",
      ExResultCopy:
        "240 位客户中，AI 已完成沟通并筛出 <strong>8 位高意向客户</strong>，随时可以约通话 ↓",
      ExMetricInterested: "意向客户 / 商机",
      ExMetricContact: "联系方式（邮箱 / 电话 / WhatsApp）",
      ExResultNote:
        "意向客户和联系方式会自动整理在这里 - 其他人（未回复 / 不匹配）自动归档，您无需在私信中翻找。",
      ExCtaCopy: "明白了？现在就用 30 秒为您的产品创建同样的获客任务。",
      ExCtaButton: "创建我的任务",
      ExProblem1: "每天在 LinkedIn 上花 4 个多小时，却一无所获？",
      ExProblem2: "半天的沉寂 - 全都白费",
      ExProblem3:
        "需要更广的触达却要买昂贵的 Sales Navigator 席位？多个 LinkedIn 账号要一起管理？",
      ExProblem4: "下班后还要在 LinkedIn 上回复客户？",
      ExBenefit1:
        "批量自动寻源和私信 - <strong>您零投入</strong>",
      ExBenefit2:
        "AI 主动筛选客户和商机，<strong>大幅节省您的时间</strong>",
      ExBenefit3:
        "AI 管理多个 LinkedIn 账号 - <strong>组建 AI 销售团队提升产出</strong>",
      ExBenefit4:
        "AI 全天候工作并及时回复 - <strong>推进更快、支持多语言</strong>",
      ExChatFeature1: "全程使用您自己的 LinkedIn",
      ExChatFeature2: "AI 多轮自动回复，答疑并跟进",
      ExChatFeature3: "自动收集联系方式",
      ExChatFeature4: "多语言对话",
      ExIndustry1: "SaaS",
      ExIndustry2: "外贸",
      ExIndustry3: "跨境电商",
      ExIndustry4: "制造业",
      ExIndustry5: "咨询",
      ExIndustry6: "广告技术",
      ExIndustry7: "金融",
      ExIndustry8: "教育",
      Interested: "有意向",
      Email: "邮箱",
      Phone: "电话",
      ExConvFooter1: "已获取邮箱 + 已约演示",
      ExConvFooter2: "已获取联系方式",
      ExModalClose: "关闭",
      ExConv1Role: "项目主管兼撰稿人",
      ExConv2Role: "SEO 专家兼网络内容营销（兼职·远程）",
      ExConv1Msg1:
        "Yohanna，您通过讲故事和疗愈带来的创意影响力令人印象深刻。我们提供引人入胜、策略性的短视频服务。<br/>通过解决低互动难题，我们部署独特的短视频流程来简化内容创作，已为客户提升了转化率和互动度。<br/>例如，Hafiz Jabbar 的金融案例用 8 条视频带来了 10 个线索。<br/>凭借独家通道和有限容量，我们的服务为提升您的数字影响力提供了难得的机会，确保先发优势。<br/>您有时间进一步聊聊吗？",
      ExConv1Msg2: "感谢分享",
      ExConv1Msg3: "好的，我们聊聊吧",
      ExConv1Msg4:
        "您是否注意到当前内容创作流程中的某些挑战，比如制作成本上升或难以保持稳定的质量？这些问题又如何影响您的整体互动目标？",
      ExConv1Msg5: "是的",
      ExConv1Msg6: "都有",
      ExConv1Msg7:
        "我们的服务以精简的方式直接解决成本效率、一致性和流程延误问题。我们准备了一个演示，会完整走一遍我们的工作流各阶段，展示每个环节如何被优化。您可以通过此链接 [ hanafi@rekastudio.co ] 查看，或直接访问我们的网站了解详情。如果方便，请留下您的电话号码，我们可以为您安排一次量身定制的快速在线演示。",
      ExConv1Msg9:
        "方便分享您偏好的联系方式吗——比如电话或 WhatsApp——以便我们安排一次快速通话并按您的需求定制演示？",
      ExConv1Msg11:
        "谢谢您。我很快会致电为您详细演示。在此期间，能否分享您的邮箱地址？这样我可以在通话前先发送一些补充资料。",
      ExConv2Msg1:
        "Ameer，看到您出色的 SEO 营销活动令人备受启发。我们为代理商提供白标分析和灵活定价。我们以独特的白标方案解决复杂的数据分析难题、简化多品牌数据；该方案已帮助客户实现 30% 的效率提升和可衡量的 ROI 增长。例如，我们的方案服务于 akulaku 和 Firstline Limited，展现了其对数字可见度的强劲影响。目前，我们独家的入驻窗口期为快速变化的数字领域中的早期采用者提供独特的竞争优势。您本周是否愿意进行一次简短的 5 分钟交流？",
      ExConv2Msg2: "听起来很有意思",
      ExConv2Msg3: "目前我也在一家代理商工作，提供正式的 SEO 服务。",
      ExConv2Msg4:
        "在代理商工作时，您是否遇到过手动报告管理难或运营成本高等阻碍 SEO 营销活动扩展的挑战？流程中是否有特定瓶颈——比如维护开销或效率问题——影响了客户效果？",
      ExConv2Msg5: "没错",
      ExConv2Msg6: "我为大小公司从零搭建过网站和业务。",
      ExConv2Msg7:
        "我们的演示展示了自定义仪表盘、白标报告和灵活的额度——非常适合服务多样化客户需求的代理商。想快速了解一下吗？如果想，请分享您偏好的联系方式（邮箱、电话等），以便我们为您设置个性化演示。",
      ExConv2Msg8: "点击或按回车键在图片预览中显示",
      ExConv2Msg9:
        "我们有一款专为像您这样的代理商定制的解决方案——具备白标仪表盘和客户门户，可随您多样化的项目灵活扩展。我很想为您安排一次个性化演示，让您看看实际效果。能否分享您最方便的联系电话或邮箱，以便我把直接访问的详情发给您？",
      ExConv2Msg10:
        "好的，+923042903762 WhatsApp [2026-01-03 05:25:43] AI：基于您丰富的网站和业务搭建经验，我们的代理商方案旨在简化您的报告和仪表盘管理。这是一个白标平台，可简化多渠道数据、减少手动报告并助力业务扩展——在类似部署中已实现 30% 的效率提升。既然您对演示感兴趣，我们诚挚邀请您注册免费试用，体验其全部功能。我会把注册详情连同直接链接通过 WhatsApp 发送给您，助您快速上手。请确认您是否准备好通过 WhatsApp 接收试用链接？",
      ExLead1Role: "工程负责人 · SaaS",
      ExLead2Role: "采购经理 · 制造业",
      ExLead3Role: "创始人 · 跨境电商",
      ExLead4Role: "营销总监 · 广告技术",
      ExLead5Role: "首席技术官 · 金融科技",
    },
    US: {
      ExBack: "Back",
      ExOverviewTitle: "Still adding and messaging people one by one on LinkedIn?",
      ExSubCopy:
        "StrategyBrain does it all automatically - <strong>for any industry or product:</strong>",
      ExPainManualTitle: "😩 Prospecting manually",
      ExPainSBTitle: "✨ With StrategyBrain",
      ExAnyIndustry: "Any industry:",
      ExAnyIndustryNote: "...any B2B business can find customers",
      ExStep1Title:
        "Auto-target customers from <strong>your own LinkedIn account</strong> - hands-free",
      ExFlowAccountTitle: "Your own LinkedIn",
      ExFlowAccountStrong: "We don't provide an account",
      ExFlowAccountP: "Customers see the real you",
      ExFlowSourceTitle: "Account auto-sources",
      ExFlowSourceStrong: "Fully automated · zero effort",
      ExFlowSourceP: "No manual searching or adding",
      ExFlowCustomersTitle: "240 target customers",
      ExFlowCustomersP: "Matched to your ICP<br />auto-added",
      ExHint:
        "Just paste one LinkedIn customer-search URL - your account handles all the prospecting automatically.",
      ExStep2Title:
        "AI chats with target customers automatically in <strong class=\"blue\">your LinkedIn inbox</strong> (works for any industry)",
      ExChatCopy:
        "The two conversations below are handled fully automatically by AI - <strong>click either one to enlarge the full transcript:</strong>",
      ExInYourLinkedIn: "Your LinkedIn",
      ExAccountNote: "Your account (sent by AI)",
      ExClickEnlarge: "Click to enlarge the full conversation",
      ExFootnote:
        "↑ SaaS, manufacturing, foreign trade... any B2B industry can be handled this way. AI follows up with all 240 target customers in parallel - you only step in when there's a result.",
      ExStep3Title:
        "Auto-screens high-intent customers - you only take over the ones with results",
      ExResultCopy:
        "Out of 240, AI has already chatted and surfaced <strong>8 high-intent customers</strong>, ready for you to book a call ↓",
      ExMetricInterested: "interested customers / opportunities",
      ExMetricContact: "contact details (email / phone / WhatsApp)",
      ExResultNote:
        "Interested customers and contact details are organized here automatically - everyone else (no reply / not a fit) is auto-archived, so you never dig through DMs.",
      ExCtaCopy:
        "Got it? Now create the same kind of lead-gen campaign for your own product in 30 seconds.",
      ExCtaButton: "Create my campaign",
      ExProblem1: "Spending 4+ hours a day on LinkedIn with nothing to show?",
      ExProblem2: "Half a day of silence - all for nothing",
      ExProblem3:
        "Need more reach with a pricey Sales Navigator seat? Multiple LinkedIn accounts to run together?",
      ExProblem4: "Still replying to customers on LinkedIn after hours?",
      ExBenefit1:
        "Auto-sources & messages in bulk - <strong>zero effort from you</strong>",
      ExBenefit2:
        "AI proactively screens customers & opportunities, <strong>cutting your hours</strong>",
      ExBenefit3:
        "AI manages multiple LinkedIn accounts - <strong>build an AI sales team for more throughput</strong>",
      ExBenefit4:
        "AI works around the clock with timely replies - <strong>faster progress, multilingual support</strong>",
      ExChatFeature1: "All on your own LinkedIn",
      ExChatFeature2: "AI auto-replies across multiple turns, answering & following",
      ExChatFeature3: "Auto-collects contact",
      ExChatFeature4: "Multilingual conversations",
      ExIndustry1: "SaaS",
      ExIndustry2: "Foreign trade",
      ExIndustry3: "Cross-border e-commerce",
      ExIndustry4: "Manufacturing",
      ExIndustry5: "Consulting",
      ExIndustry6: "Adtech",
      ExIndustry7: "Finance",
      ExIndustry8: "Education",
      Interested: "Interested",
      Email: "Email",
      Phone: "Phone",
      ExConvFooter1: "Email captured + demo booked",
      ExConvFooter2: "Contact captured",
      ExModalClose: "Close",
      ExConv1Role: "Programme Executive and Writer",
      ExConv2Role: "SEO Expert & Web Content Marketing (Part-Time, Remote)",
      ExConv1Msg1:
        "Yohanna, impressed by your creative impact through storytelling and healing. We deliver an engaging, strategic short-form video service. <br/> By tackling low engagement challenges, we deploy our unique short-form video process that streamlines content creation. This approach has elevated conversion rates and engagement for our clients. <br/>For example, Hafiz Jabbar’s finance case produced 10 leads from 8 videos. <br/> With exclusive access and limited capacity, our service offers a rare chance to boost your digital presence, ensuring early mover advantage. <br/>Do you have a few minutes to discuss this further?",
      ExConv1Msg2: "Thanks for sharing",
      ExConv1Msg3: "Sure, let's talk",
      ExConv1Msg4:
        "Have you noticed any particular challenges with your current content creation process, like rising production costs or difficulty in maintaining consistent quality? Also, how do these issues impact your overall engagement goals?",
      ExConv1Msg5: "Yeah",
      ExConv1Msg6: "All",
      ExConv1Msg7:
        "Our service directly tackles cost efficiency, consistency, and process delays with a streamlined approach. We've set up a demo that walks through our workflow stages and shows how each area is optimized. You can check it out via this link [ hanafi@rekastudio.co ] or directly visit our website for more details. If you prefer, share your phone number, and we can schedule a quick live walkthrough tailored to your needs.",
      ExConv1Msg9:
        "Would you mind sharing your preferred contact detail—like your phone number or WhatsApp—so we can schedule a quick call and tailor the demo to your needs?",
      ExConv1Msg11:
        " Thanks for that. I'll give you a call soon to walk through a detailed demo. In the meantime, could you share your email address? It will help me send over some additional details ahead of our call.",
      ExConv2Msg1:
        "Ameer, noticing your impressive SEO campaigns inspires innovation. We empower agencies with white-label analytics and flexible pricing. We tackle complex analytics challenges with a unique white-label approach that streamlines multi-brand data; our solution has helped clients achieve 30% efficiency increases and measurable ROI gains. For instance, our solution supports akulaku and Firstline Limited, demonstrating its robust impact on digital visibility. Currently, our exclusive onboarding window provides a unique competitive edge for early adopters in the rapidly evolving digital space. Would you be open to a brief 5-minute conversation this week?",
      ExConv2Msg2: "Sounds interesting",
      ExConv2Msg3:
        "Currently I'm also working for a agency and providing official SEO services.",
      ExConv2Msg4:
        "Working in an agency, do you ever face challenges like managing manual reporting or high operational costs that hold back scaling your SEO campaigns? Are there particular bottlenecks in your process—like maintenance overhead or efficiency issues—that impact client results?",
      ExConv2Msg5: "Exactly",
      ExConv2Msg6:
        " I have build scratched websites and business for small and large companies.",
      ExConv2Msg7:
        "Our demo showcases custom dashboards, white-label reports, and flexible credits—ideal for agencies handling diverse client needs. Would you like a quick look? If so, please share your preferred contact details ( email, phone, etc. ) so we can set up your personalized demo.",
      ExConv2Msg8: "Click or press enter to display in the image preview",
      ExConv2Msg9:
        "We've got a tailored solution built for agencies like yours—featuring white-label dashboards and client portals that scale with your diverse projects. I'd love to set you up with a personalized demo so you can see it in action. Could you share your best contact number or email so I can send you direct access details?",
      ExConv2Msg10:
        "Sure, +923042903762 WhataApp [2026-01-03 05:25:43] AI: Based on your extensive experience building websites and businesses, our agency solution is designed to simplify your reporting and dashboard management. It’s a white-label platform that streamlines multi-channel data, reducing manual reporting while helping scale operations—evidenced by a 30% efficiency boost in similar deployments. Since you're interested in a demo, we'd like to invite you to register for a free trial to experience its full capabilities. I'll send you the registration details along with a direct link on WhatsApp to get you started. Could you please confirm if you're ready to receive the trial link via WhatsApp?",
      ExLead1Role: "Head of Engineering · SaaS",
      ExLead2Role: "Procurement Manager · Manufacturing",
      ExLead3Role: "Founder · Cross-border e-commerce",
      ExLead4Role: "Marketing Director · Adtech",
      ExLead5Role: "CTO · Fintech",
    },
    AR: {
      ExBack: "رجوع",
      ExOverviewTitle:
        "هل ما زلت تضيف الأشخاص وتراسلهم واحدًا تلو الآخر على LinkedIn؟",
      ExSubCopy:
        "StrategyBrain يفعل كل ذلك تلقائيًا - <strong>لأي صناعة أو منتج:</strong>",
      ExPainManualTitle: "😩 البحث اليدوي عن العملاء",
      ExPainSBTitle: "✨ مع StrategyBrain",
      ExAnyIndustry: "أي صناعة:",
      ExAnyIndustryNote: "...أي عمل B2B يمكنه العثور على عملاء",
      ExStep1Title:
        "استهداف تلقائي للعملاء من <strong>حسابك الخاص على LinkedIn</strong> - دون أي جهد",
      ExFlowAccountTitle: "حسابك الخاص على LinkedIn",
      ExFlowAccountStrong: "نحن لا نوفر حسابًا",
      ExFlowAccountP: "العملاء يرون الشخص الحقيقي",
      ExFlowSourceTitle: "الحساب يبحث تلقائيًا",
      ExFlowSourceStrong: "مؤتمت بالكامل · بدون جهد",
      ExFlowSourceP: "لا بحث أو إضافة يدوية",
      ExFlowCustomersTitle: "240 عميلًا مستهدفًا",
      ExFlowCustomersP: "مطابقون لملف عميلك المثالي<br />يُضافون تلقائيًا",
      ExHint:
        "ما عليك سوى لصق رابط بحث واحد عن العملاء على LinkedIn - ويتولى حسابك كل عملية البحث عن العملاء تلقائيًا.",
      ExStep2Title:
        "الذكاء الاصطناعي يتحادث مع العملاء المستهدفين تلقائيًا في <strong class=\"blue\">صندوق بريد LinkedIn الخاص بك</strong> (يعمل لأي صناعة)",
      ExChatCopy:
        "المحادثتان أدناه يديرهما الذكاء الاصطناعي بالكامل - <strong>انقر على أي منهما لتكبير النص الكامل:</strong>",
      ExInYourLinkedIn: "في LinkedIn الخاص بك",
      ExAccountNote: "حسابك (أرسله الذكاء الاصطناعي)",
      ExClickEnlarge: "انقر لتكبير المحادثة الكاملة",
      ExFootnote:
        "↑ SaaS، التصنيع، التجارة الخارجية... يمكن التعامل مع أي صناعة B2B بهذه الطريقة. يتابع الذكاء الاصطناعي مع جميع العملاء المستهدفين الـ 240 بالتوازي - ولا تتدخل إلا عندما تكون هناك نتيجة.",
      ExStep3Title:
        "فرز تلقائي للعملاء ذوي النية العالية - تتولى فقط من لديهم نتائج",
      ExResultCopy:
        "من أصل 240، تحادث الذكاء الاصطناعي بالفعل وأبرز <strong>8 عملاء ذوي نية عالية</strong>، جاهزين لحجز مكالمة ↓",
      ExMetricInterested: "عملاء مهتمون / فرص",
      ExMetricContact: "تفاصيل الاتصال (بريد إلكتروني / هاتف / واتساب)",
      ExResultNote:
        "يتم تنظيم العملاء المهتمين وتفاصيل الاتصال هنا تلقائيًا - ويؤرشف الباقون تلقائيًا (بلا رد / غير مناسبين)، فلا تحتاج أبدًا للبحث في الرسائل.",
      ExCtaCopy:
        "فهمت؟ الآن أنشئ حملة جذب عملاء مماثلة لمنتجك في 30 ثانية.",
      ExCtaButton: "أنشئ حملتي",
      ExProblem1: "تقضي أكثر من 4 ساعات يوميًا على LinkedIn دون نتيجة تُذكر؟",
      ExProblem2: "نصف يوم من الصمت - كله بلا فائدة",
      ExProblem3:
        "تحتاج وصولًا أوسع مع مقعد Sales Navigator باهظ الثمن؟ عدة حسابات LinkedIn لإدارتها معًا؟",
      ExProblem4: "ما زلت ترد على العملاء على LinkedIn بعد ساعات العمل؟",
      ExBenefit1:
        "بحث ومراسلة تلقائية بالجملة - <strong>بلا أي جهد منك</strong>",
      ExBenefit2:
        "الذكاء الاصطناعي يفرز العملاء والفرص استباقيًا، <strong>مقلصًا ساعات عملك</strong>",
      ExBenefit3:
        "يدير الذكاء الاصطناعي عدة حسابات LinkedIn - <strong>ابنِ فريق مبيعات ذكاء اصطناعي لمخرجات أكبر</strong>",
      ExBenefit4:
        "يعمل الذكاء الاصطناعي على مدار الساعة بردود في وقتها - <strong>تقدم أسرع ودعم متعدد اللغات</strong>",
      ExChatFeature1: "كله على LinkedIn الخاص بك",
      ExChatFeature2: "ردود تلقائية متعددة الأدوار، إجابة ومتابعة",
      ExChatFeature3: "جمع تلقائي لطرق الاتصال",
      ExChatFeature4: "محادثات متعددة اللغات",
      ExIndustry1: "SaaS",
      ExIndustry2: "التجارة الخارجية",
      ExIndustry3: "التجارة الإلكترونية العابرة للحدود",
      ExIndustry4: "التصنيع",
      ExIndustry5: "الاستشارات",
      ExIndustry6: "تكنولوجيا الإعلانات",
      ExIndustry7: "التمويل",
      ExIndustry8: "التعليم",
      Interested: "مهتم",
      Email: "بريد إلكتروني",
      Phone: "هاتف",
      ExConvFooter1: "تم التقاط البريد الإلكتروني + حجز العرض التوضيحي",
      ExConvFooter2: "تم التقاط بيانات الاتصال",
      ExModalClose: "إغلاق",
      ExConv1Role: "منفذة برامج وكاتبة",
      ExConv2Role: "خبير SEO وتسويق المحتوى الرقمي (دوام جزئي، عن بُعد)",
      ExConv1Msg1:
        "يوهانا، أبهرني تأثيرك الإبداعي من خلال سرد القصص والشفاء. نقدم خدمة فيديو قصيرة جذابة واستراتيجية. <br/> من خلال معالجة تحديات التفاعل المنخفض، نطبق عملية الفيديو القصيرة الفريدة لدينا التي تبسط إنشاء المحتوى، وقد رفعت هذه المقاربة معدلات التحويل والتفاعل لدى عملائنا. <br/>على سبيل المثال، حققت حالة Hafiz Jabbar المالية 10 عملاء محتملين من 8 مقاطع فيديو. <br/> مع الوصول الحصري والقدرة المحدودة، تتيح خدمتنا فرصة نادرة لتعزيز حضورك الرقمي وضمان ميزة السبق. <br/>هل لديك بضع دقائق لمناقشة هذا بشكل أعمق؟",
      ExConv1Msg2: "شكرًا للمشاركة",
      ExConv1Msg3: "بالتأكيد، لنتحدث",
      ExConv1Msg4:
        "هل لاحظت أي تحديات معينة في عملية إنشاء المحتوى الحالية لديك، مثل ارتفاع تكاليف الإنتاج أو صعوبة الحفاظ على جودة متسقة؟ وكيف تؤثر هذه المشكلات على أهداف التفاعل العامة لديك؟",
      ExConv1Msg5: "نعم",
      ExConv1Msg6: "كلها",
      ExConv1Msg7:
        "تتناول خدمتنا مباشرة كفاءة التكاليف والاتساق وتأخيرات العمليات بمنهجية مبسطة. أعددنا عرضًا توضيحيًا يستعرض مراحل سير عملنا ويبين كيفية تحسين كل جانب. يمكنك الاطلاع عليه عبر هذا الرابط [ hanafi@rekastudio.co ] أو زيارة موقعنا الإلكتروني مباشرةً لمزيد من التفاصيل. وإذا فضّلت ذلك، شاركنا رقم هاتفك ويمكننا جدولة جولة مباشرة سريعة مصممة وفق احتياجاتك.",
      ExConv1Msg9:
        "هل يمكنك مشاركة وسيلة الاتصال المفضلة لديك — مثل رقم هاتفك أو واتساب — حتى نتمكن من جدولة مكالمة سريعة وتخصيص العرض التوضيحي وفق احتياجاتك؟",
      ExConv1Msg11:
        " شكرًا لذلك. سأتصل بك قريبًا لاستعراض عرض توضيحي مفصل. في هذه الأثناء، هل يمكنك مشاركة عنوان بريدك الإلكتروني؟ سيساعدني ذلك على إرسال بعض التفاصيل الإضافية قبل مكالمتنا.",
      ExConv2Msg1:
        "أمير، إن مشاهدة حملات SEO الرائعة لديك تلهم الابتكار. نمكّن الوكالات من تحليلات العلامة البيضاء وتسعير مرن. نتناول تحديات التحليلات المعقدة بمنهجية علامة بيضاء فريدة تبسط بيانات العلامات المتعددة؛ وقد ساعد حلنا العملاء على تحقيق زيادة 30% في الكفاءة ومكاسب ROI قابلة للقياس. على سبيل المثال، يدعم حلنا شركة akulaku وFirstline Limited، مما يبرهن على تأثيره القوي على الظهور الرقمي. حاليًا، توفر نافذة الانضمام الحصرية لدينا ميزة تنافسية فريدة للمتبنين الأوائل في الفضاء الرقمي سريع التطور. هل ستكون منفتحًا على محادثة قصيرة مدتها 5 دقائق هذا الأسبوع؟",
      ExConv2Msg2: "يبدو مثيرًا للاهتمام",
      ExConv2Msg3: "حاليًا أعمل أيضًا في وكالة وأقدم خدمات SEO رسمية.",
      ExConv2Msg4:
        "وأنت تعمل في وكالة، هل تواجه أحيانًا تحديات مثل إدارة التقارير اليدوية أو التكاليف التشغيلية المرتفعة التي تعيق توسيع حملات SEO لديك؟ هل توجد اختناقات معينة في عمليتك — مثل أعباء الصيانة أو مشكلات الكفاءة — تؤثر على نتائج العملاء؟",
      ExConv2Msg5: "بالضبط",
      ExConv2Msg6: " لقد قمت ببناء مواقع وكيانات تجارية من الصفر لشركات صغيرة وكبيرة.",
      ExConv2Msg7:
        "يعرض العرض التوضيحي لدينا لوحات معلومات مخصصة وتقارير بعلامة بيضاء وأرصدة مرنة — مثالي للوكالات التي تخدم احتياجات عملاء متنوعة. هل تود نظرة سريعة؟ إذا كان الأمر كذلك، يرجى مشاركة تفاصيل الاتصال المفضلة لديك ( البريد الإلكتروني، الهاتف، إلخ ) حتى نتمكن من إعداد عرض توضيحي مخصص لك.",
      ExConv2Msg8: "انقر أو اضغط على Enter للعرض في معاينة الصورة",
      ExConv2Msg9:
        "لدينا حل مصمم خصيصًا لوكالات مثل وكالتك — يضم لوحات معلومات بعلامة بيضاء وبوابات عملاء تتوسع مع مشاريعك المتنوعة. يسعدني أن أجهز لك عرضًا توضيحيًا مخصصًا لتراه أثناء العمل. هل يمكنك مشاركة رقم الاتصال أو البريد الإلكتروني الأفضل لديك حتى أرسل لك تفاصيل الوصول المباشر؟",
      ExConv2Msg10:
        "بالتأكيد، +923042903762 واتساب [2026-01-03 05:25:43] الذكاء الاصطناعي: بناءً على خبرتك الواسعة في بناء المواقع والكيانات التجارية، صُمم حل الوكالات لدينا لتبسيط إدارة التقارير ولوحات المعلومات لديك. إنها منصة بعلامة بيضاء تبسط بيانات القنوات المتعددة وتقلل التقارير اليدوية مع المساعدة في توسيع العمليات — ويشهد على ذلك تعزيز الكفاءة بنسبة 30% في عمليات نشر مماثلة. وبما أنك مهتم بالعرض التوضيحي، يسعدنا دعوتك للتسجيل في تجربة مجانية لتجربة قدراتها الكاملة. سأرسل لك تفاصيل التسجيل مع رابط مباشر عبر واتساب للبدء. هل يمكنك تأكيد استعدادك لاستلام رابط التجربة عبر واتساب؟",
      ExLead1Role: "رئيس الهندسة · SaaS",
      ExLead2Role: "مدير المشتريات · التصنيع",
      ExLead3Role: "مؤسس · التجارة الإلكترونية العابرة للحدود",
      ExLead4Role: "مدير التسويق · تكنولوجيا الإعلانات",
      ExLead5Role: "المدير التقني · التقنية المالية",
    },
  },
};
